var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgA2SecondaryPowerSupply(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 76,
    height: 76,
    viewBox: "0 0 76 76",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31 30h-7v7h-4v-7h-7v-4h7v-7h4v7h7v4zm13 .36V7h-4v23.36L29 49h11v20h4V49h11L44 30.36z",
    fill: "currentColor"
  })));
}
export default __webpack_public_path__ + "static/media/A2_Secondary_Power_Supply.50f73877.svg";
export { SvgA2SecondaryPowerSupply as ReactComponent };